export default {"src":"/_next/static/media/RelatedServiceLoanPortalIcon.f2fda2c1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};